/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_DescriptionInputs */

const en_blog_description = /** @type {(inputs: Blog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practical CADCraft guides, command-line workflows, and AutoCAD comparisons.`)
};

/**
* | output |
* | --- |
* | "Practical CADCraft guides, command-line workflows, and AutoCAD comparisons." |
*
* @param {Blog_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const blog_description = /** @type {((inputs?: Blog_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_blog_description(inputs)
});
export { blog_description as "blog.description" }